import { FC } from 'react';
import { Button, ButtonSize, ButtonVariant } from '@edikk-edikk/country-layout-black';
import { useIsFrontendStyleDefault } from '@edikk-edikk/country-frontend';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import { AppSvgSpriteMonoIcon } from '#src/svg';

const GalleryHeaderClose: FC = () => {
  const { onClose } = useAdvertDetailContext();
  const isFrontendStyleDefault = useIsFrontendStyleDefault();

  if (!onClose) {
    return null;
  }

  return (
    <Button
      variant={isFrontendStyleDefault ? ButtonVariant.black : ButtonVariant.blackRose}
      size={ButtonSize.lg}
      circle
      onClick={onClose}
      aria-label="Close"
    >
      <AppSvgSpriteMonoIcon name="cross" size={18} />
    </Button>
  );
};

export { GalleryHeaderClose };
